import { Img } from 'components/shared';
import Notification from 'components/Notification';
import * as React from 'react';
export default {
  Img,
  Notification,
  React
};